import React, { useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from './LanguageContext';
const videos = [{
  id: 'M9CN3TYyvUw',
  label: 'Live Show 1'
}, {
  id: '8fl3xHEit4k',
  label: 'In Studio 2'
}, {
  id: 'LVc0jS-bkNk',
  label: 'In Studio 3'
}];
export function Video() {
  const {
    t
  } = useLanguage();
  const [active, setActive] = useState(0);
  return <section className="relative py-20 md:py-28 bg-ink2 overflow-hidden" data-id="element-208">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(212,164,55,0.08),_transparent_60%)] pointer-events-none" data-id="element-209" />
      <div className="relative max-w-5xl mx-auto px-6 lg:px-10" data-id="element-210">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-211">
          <p className="text-gold text-xs tracking-[0.3em] mb-4" data-id="element-212">
            {t('video.eyebrow')}
          </p>
          <h2 className="font-display text-4xl md:text-5xl text-cream leading-tight mb-4" data-id="element-213">
            {t('video.title.1')}{' '}
            <span className="italic gold-text" data-id="element-214">{t('video.title.2')}</span>
          </h2>
          <p className="text-cream/60 max-w-xl mx-auto" data-id="element-215">
            {t('video.subtitle')}
          </p>
        </motion.div>

        {/* Video tabs */}
        <div className="flex justify-center gap-2 mb-6" data-id="element-216">
          {videos.map((v, i) => <button key={v.id} onClick={() => setActive(i)} className={`px-5 py-2 rounded-full text-xs tracking-[0.2em] uppercase transition-colors border ${active === i ? 'bg-gold text-ink border-gold' : 'border-gold/30 text-cream/70 hover:border-gold hover:text-gold'}`} data-id="element-217">
              {v.label}
            </button>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="relative" data-id="element-218">
          <div className="absolute -inset-2 md:-inset-3 border border-gold/30 rounded-sm pointer-events-none" data-id="element-219" />
          <div className="relative aspect-video overflow-hidden rounded-sm bg-ink shadow-2xl shadow-gold/10" data-id="element-220">
            <AnimatePresence mode="wait" data-id="element-221">
              <motion.iframe key={videos[active].id} initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} exit={{
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="absolute inset-0 w-full h-full" src={`https://www.youtube.com/embed/${videos[active].id}?rel=0`} title={`Jade Latin Music — ${videos[active].label}`} loading="lazy" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen data-id="element-222" />
            </AnimatePresence>
          </div>
        </motion.div>
      </div>
    </section>;
}